import { Accordion, AccordionDetails, AccordionSummary, Box, Collapse, useTheme } from "@material-ui/core";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LyfeTypography from "../../../../../../libs/react-common/src/Typography/Typography";
import useStyles from "../../containers/data/forms/forms-styles";
import { SectionBodyInstances } from "./SectionBodyInstances";
import { ISectionRenderProps } from "./SectionRoot";

export const DynamicSection: React.FC<ISectionRenderProps> = (props) => {
	const { controller, sectionPath } = props;
	const { bodyItemHeaderTop, sectionDetails } = useStyles();
	const { palette, spacing } = useTheme();
	const { t } = useTranslation();
	const isOpenByDefault = controller.useIsSectionOpenByDefault ? controller.useIsSectionOpenByDefault() : true;
	const [isOpen, setIsOpen] = useState(!!controller.context.isEditable && isOpenByDefault);
	const infoMessage = props.controller?.useGetInfoMessage?.();

	function handleToggleChange() {
		return setIsOpen(!isOpen);
	}

	return (
		<Accordion
			expanded={true}
			defaultExpanded
			onChange={handleToggleChange}
			TransitionProps={{ unmountOnExit: true }}
			style={{ borderRadius: "4px 4px 0px 0px", marginTop: 0, marginBottom: spacing(3) }}
			elevation={0}
		>
			<AccordionSummary
				className={bodyItemHeaderTop}
				expandIcon={isOpen ? <ExpandMoreIcon color={"inherit"} /> : <ExpandLessIcon color={"inherit"} />}
				aria-controls={t(controller.schema.localizableKey || "")}
			>
				<Box display="flex" alignItems="center">
					<LyfeTypography noWrap type="h7" style={{ color: palette.widgetHeaderText.main }}>
						{t(controller?.schema.localizableKey || "")}
					</LyfeTypography>
					{infoMessage && (
						<LyfeTypography noWrap type="fieldText" style={{ marginLeft: "3em" }}>
							{infoMessage}
						</LyfeTypography>
					)}
				</Box>
			</AccordionSummary>
			<AccordionDetails className={sectionDetails}>
				<Collapse in={isOpen} style={{ width: "100%" }}>
					{controller.renderAfterHeader?.(sectionPath)}
					<SectionBodyInstances {...props} />
				</Collapse>
			</AccordionDetails>
		</Accordion>
	);
};
